// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedTableToolbar-ColumnVisibilityButton-ColumnVisibilityButton-module__dropdownBox--Wm2tp {
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedTableToolbar-ColumnVisibilityButton-ColumnVisibilityButton-module__dropdownBox--Wm2tp > div {
  padding: 8px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsScheduling/SchedulingControl/SchedulingTable/SchedTableToolbar/ColumnVisibilityButton/ColumnVisibilityButton.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAAE;EACE,iBAAA;AAEJ","sourcesContent":[".dropdownBox {\n  display: flex;\n  flex-direction: column;\n  & > div {\n    padding: 8px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownBox": `src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedTableToolbar-ColumnVisibilityButton-ColumnVisibilityButton-module__dropdownBox--Wm2tp`
};
export default ___CSS_LOADER_EXPORT___;
